import React from 'react';
import { useTranslation } from 'react-i18next';
import DynamicCrudPage from '../../../components/DynamicCrudPage';
import { useTags, useCompanies } from '../../../hooks';
import AddIcon from '@mui/icons-material/Add';

const TagsPage = () => {
  const { t } = useTranslation();

  return (
    <DynamicCrudPage
      entityType="tags"
      hook={useTags}
      additionalHooks={{
        companies: useCompanies,
      }}
      addButtonTextKey="table.actions.addTag"
      addButtonIcon={<AddIcon />}
      entityTypeForDataTable="tag"
    />
  );
};

export default TagsPage;
